module.exports = __webpack_public_path__ + "6235e7ffd5be05f6c12e0e51bf5f5b68.png";